<template>
  <div class="container">
    <HeaderView />
    <div :class="{
      'bg-content': $store.state.screenWidth > 375,
      'bg-content-se': $store.state.screenWidth <= 375,
      'bg-content-4': $store.state.screenWidth <= 320,
    }">
      <div class="form-page">
        <div class="form-card">
          <div class="form-heading">
            <span class="heading-icon"><img src="/static/img/logo/open-house-2026.png" alt="RMUTL Open House 2026" /></span>
            <div>
              <p>RMUTL Open House</p>
              <h2>ลงทะเบียน</h2>
            </div>
          </div>
          <form id="formprofile" class="needs-validation form-grid" novalidate autocomplete="off">
            <div class="form-field">
              <label>เลขบัตรประชาชนหรือเลขพาสปอร์ต/Citizen&Passportid</label>
              <input class="form-control" type="text" v-model="citizen_id" autocomplete="off" required readonly />
            </div>
            <div class="form-field">
              <label>เพศ/Gender</label>
              <select class="form-select" :class="validationClass('gender')" v-model="gender" required>
                <option :value="0">กรุณาเลือกเพศ</option>
                <option :value="1">ชาย</option>
                <option :value="2">หญิง</option>
              </select>
            </div>
            <div class="form-field">
              <label>ชื่อ - นามสกุล/Fullname</label>
              <input class="form-control" :class="validationClass('fullname')" type="text" v-model="fullname"
                autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>เบอร์โทรศัพท์/Telephone</label>
              <input class="form-control" :class="validationClass('tel')" type="text" v-model="tel"
                v-mask="'###-###-####'" autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>อีเมล/Email</label>
              <input class="form-control" :class="validationClass('email')" type="email" v-model="email"
                autocomplete="off" required />
            </div>
            <div class="form-field">
              <label>ภูมิลำเนา/Origin Province</label>
              <Select2 class="regis-select2 d-block" :class="validationClass('origin_province_id')"
                :data="provinceOptions" :value="origin_province_id" :min-count-for-search="0"
                @update="origin_province_id = $event" />
              <input type="hidden" name="origin_province" :value="origin_province_id" />
            </div>
            <div class="form-field">
              <label>สถานศึกษาปัจจุบัน/School</label>
              <vue-bootstrap-typeahead :inputClass="schoolInputClass" v-model="school" :data="school_lists" />
            </div>
            <div class="form-field">
              <label>สถานะผู้เข้าร่วม/Participant Status</label>
              <select class="form-select" :class="validationClass('participant_status')" name="status"
                v-model="participant_status">
                <option :value="0">กรุณาเลือกสถานะผู้เข้าร่วม</option>
                <option value="นักเรียน">นักเรียน</option>
                <option value="นักศึกษา">นักศึกษา</option>
                <option value="อาจารย์แนะแนว">อาจารย์แนะแนว</option>
                <option value="บุคคลทั่วไป">บุคคลทั่วไป</option>
              </select>
            </div>
            <div class="form-field">
              <label>เขตพื้นที่ที่สนใจ/Campus</label>
              <select class="form-select" :class="validationClass('campus_id')" name="campus" v-model="campus_id">
                <option :value="0">กรุณาเลือกเขตพื้นที่</option>
                <option v-for="(cp, i) in campus_list" :key="'rcf' + i" :value="cp.campus_id_pri">
                  {{ cp.campus_name }}
                </option>
              </select>
            </div>
            <div class="form-field">
              <label>คณะที่สนใจ/faculty</label>
              <select class="form-select" :class="validationClass('facId')" name="faculty" v-model="facId">
                <option :value="0">กรุณาเลือกคณะ</option>
                <option v-for="(fac, i) in fac_list" :key="'rcf' + i" :value="fac.faculty_id">
                  {{ fac.faculty_name }}
                </option>
              </select>
            </div>
            <div class="form-field field-wide">
              <label>สาขาวิชาที่สนใจ/major</label>
              <Select2 class="regis-select2 d-block" :class="validationClass('major')" :data="majorOptions"
                :value="major" :min-count-for-search="0" @update="major = $event" />
              <input type="hidden" name="major" :value="major" />
            </div>
          </form>
          <div class="form-actions">
            <button class="btn btn-primary-action" @click="validateForm">
              <i class="ti ti-device-floppy"></i>
              <span>บันทึก</span>
            </button>
            <button class="btn btn-secondary-action" @click="$router.push('/')">
              <i class="ti ti-chevron-left"></i>
              <span>ย้อนกลับ</span>
            </button>
          </div>
        </div>
      </div>
      <div style="height: 100px;" />
    </div>
    <!-- model consent -->
    <button type="button" id="consentRule" data-bs-toggle="modal" data-bs-target="#consentModal"
      style="display: none;"></button>

    <!-- Modal -->
    <div class="modal fade" id="consentModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="consentModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h2 class="text-center">เงื่อนไขและข้อตกลงในการใช้บริการ</h2>
            <div class="text-left">
              &emsp;&emsp;มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา (ต่อไปนี้จะแทนด้วย
              “มทร.ล้านนา”) ได้ตระหนักถึงความสำคัญในการคุ้มครองข้อมูลส่วนบุคคล
              (Personal Data Protection Policy) ขึ้น
              โดยนโยบายดังกล่าวจะหมายรวมไปถึงการปฏิบัติต่อข้อมูลส่วนบุคคลของผู้ใช้
              เช่น การจัดเก็บข้อมูล การเก็บรักษา การประมวลผล การเปิดเผย
              สิทธิการเข้าถึงข้อมูล รวมถึงสิทธิต่าง ๆ ของแต่ละผู้ใช้เป็นต้น
              เพื่อให้เจ้าของข้อมูลได้ทราบถึงนโยบายในการคุ้มครองข้อมูลส่วนบุคคล
              มทร.ล้านนา จึงขอประกาศเงื่อนไขและข้อตกลงการใช้บริการ ดังนี้
            </div>
            <div class="text-left mt-2">
              <b>1.คำนิยาม</b>
              <br />
              &emsp;&emsp;“ผู้ใช้” หมายความว่า บุคคลหรือเจ้าของข้อมูลส่วนบุคคล
              หรือเป็นบุคคลใด ๆ ที่เกี่ยวข้องกับกิจกรรมและการดำเนินงานต่าง ๆ ที่
              มทร.ล้านนา ได้ทำการรวบรวมและประมวลผลข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลเกี่ยวกับผู้ใช้
              ซึ่งจะทำให้สามารถระบุตัวตนของบุคคลนั้นได้
              ไม่ว่าจะทางตรงหรือทางอ้อม
              แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“ผู้ควบคุมข้อมูลส่วนบุคคล” หมายความว่า
              บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม
              ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล” หมายความว่า
              พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              และกฎหมายที่เกี่ยวข้อง
              อีกทั้งให้หมายความรวมถึงกฎหมายฉบับแก้ไขเพิ่มในอนาคต
              <br />
              &emsp;&emsp;“การประมวลผล” หมายความว่า การดำเนินการใด ๆ
              กับข้อมูลส่วนบุคคลไม่ว่าจะด้วยวิธีการอัตโนมัติหรือไม่ก็ตาม เช่น
              การบันทึก การวิเคราะห์ การตั้งค่า การประเมิน การตรวจสอบมาตรฐาน
              การปรับเปลี่ยนหรือการดัดแปลง การเรียกคืน การใช้ การเปิดเผย
              (โดยการส่ง โอน
              การเผยแพร่หรือการทำให้สามารถเข้าถึงหรือพร้อมใช้งานโดยวิธีใด ๆ)
              การจัดเรียง การนำมารวมกัน การลบหรือการทำลาย เป็นต้น
            </div>
            <div class="text-left mt-2">
              <b>2.การเก็บรวบรวมข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp;2.1 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา
              เก็บรวบรวมภายใต้คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ ประกอบไปด้วย
              ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน ชื่อสถานศึกษา
              คณะที่สนใจและหลักสูตรที่มีความสนใจ
              <br />
              &emsp;&emsp;2.2
              ในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้วัตถุประสงค์ของ
              มทร.ล้านนา เท่านั้น โดยจะดำเนินการให้เจ้าของข้อมูล รับรู้
              ให้ความยินยอมทางอิเล็กทรอนิกส์ หรือตามแบบวิธีการของ มทร.ล้านนา
              กรณีที่ มทร.ล้านนา จัดเก็บข้อมูลส่วนบุคคลอ่อนไหวของเจ้าของข้อมูล
              จะขอความยินยอมจากเจ้าของข้อมูลโดยชัดแจ้งก่อนทำการเก็บรวบรวม
              เว้นแต่การเก็บข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลอ่อนไหวจะเข้าข้อยกเว้นตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
              พ.ศ. 2562 หรือกฎหมายอื่นที่เกี่ยวข้อง
            </div>
            <div class="text-left mt-2">
              <b>3.วัตถุประสงค์ในการเก็บรวบรวม หรือใช้ข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; 3.1 มทร.ล้านนา จะทำการเก็บรวบรวมข้อมูลส่วนบุคคลโดยมี
              วัตถุประสงค์ ขอบเขต และใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม
              โดยในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้
              วัตถุประสงค์ของ มทร.ล้านนา โดยคำนึงถึงการคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp; 3.2
              วัตถุประสงค์ในการเก็บรวบรวมข้อมูลและใช้ข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;&emsp;&emsp;3.2.1
              เพื่อนำข้อมูลไปปรับปรุงและพัฒนาระบบดังกล่าวให้ดียิ่งขึ้นและตรงกับความต้องการของผู้ใช้
              <br />
              &emsp;&emsp;&emsp;&emsp;3.2.2
              เพื่อนำข้อมูลการใช้งานดำเนินการประมวลผลเชิงลึก
              ในรูปแบบฐานข้อมูลขนาดใหญ่
              สำหรับใช้ในการประเมินประสิทธิภาพและประสิทธิผลของการใช้งานระบบ
              <br />
              &emsp;&emsp; 3.3 มทร.ล้านนา
              ได้เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่านผ่านช่องทางต่าง ๆ ดังนี้
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.1 ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับ
              มทร.ล้านนา ท่านอาจให้ข้อมูลส่วนบุคคลแก่ มทร.ล้านนา โดยตรง
              กรณีนี้มักเกิดขึ้นเมื่อท่านติดต่อกับ มทร.ล้านนา เพื่อสอบถาม
              กรอกแบบฟอร์มต่าง ๆ โดยทางออนไลน์หรือโดยเอกสาร
              เพื่อสมัครใช้บริการหรือร่วมกิจกรรม สอบถามข้อมูล
              หรือให้ความเห็น/คำติชมแก่ มทร.ล้านนา เป็นต้น
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.2
              ข้อมูลส่วนบุคคลที่เก็บรวบรวมจากท่านโดยอัตโนมัติ มทร.ล้านนา
              อาจเก็บรวบรวมข้อมูลทางเทคนิคบางอย่างเกี่ยวกับอุปกรณ์
              กิจกรรมและรูปแบบการเข้าชม ข้อมูลประวัติการใช้งานเว็บไซต์
              (Browsing) ของท่านโดยอัตโนมัติโดยใช้คุกกี้ (Cookies)
              และเทคโนโลยีอื่น ๆ ที่คล้ายคลึงกัน
              รายละเอียดเพิ่มเติมโปรดดูเพิ่มเติมที่ “นโยบายการใช้คุกกี้”
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.3 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา
              ได้รับมาจากบุคคลหรือหน่วยงานภายนอก มทร.ล้านนา
              อาจได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลภายนอกเป็นครั้งคราว อาทิ
              ตัวแทน นายหน้า ผู้ให้บริการ และหน่วยงานของรัฐ
              <br />
              &emsp;&emsp;3.4 ในการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้
              ผู้ใช้จะได้รับการแจ้งถึงรายละเอียดต่าง ๆ
              ตามที่ระบุในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้
              ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะพื้นฐานทางกฎหมายในการเก็บรวบรวม ใช้
              และ/หรือเปิดเผยข้อมูลส่วนบุคคลภายใต้วัตถุประสงค์อันชอบด้วยกฎหมาย
              หรือหากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้ต้องได้รับความยินยอมจากผู้ใช้
              มทร.ล้านนา
              จะขอความยินยอมโดยชัดแจ้งจากผู้ใช้เพื่อให้สามารถประมวลผลข้อมูลส่วนบุคคลของผู้ใช้ได้
              <br />
              &emsp;&emsp;3.5
              ข้อมูลที่ได้จากผู้ใช้จะถูกนำไปประมวลผลและแสดงผลตามวัตถุประสงค์ของการ
              และจะทำการเปิดเผยตามวัตถุประสงค์ที่แจ้งไว้
            </div>
            <div class="text-left mt-2">
              <b>4. การเปิดเผยข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; 4.1 ข้อมูลส่วนบุคคลที่ได้รับ มทร.ล้านนา
              จะเก็บรวบรวมข้อมูลต่อเมื่อได้รับความยินยอมจากท่านตามที่กฎหมายกำหนด
              เว้นแต่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.1 ข้อมูลส่วนบุคคลของท่านที่ มทร.ล้านนา
              ดำเนินเก็บรวบรวม ใช้ และ/หรือเปิดเผย เช่น ข้อมูลส่วนตัว เช่น
              ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.2 ข้อมูลเพื่อการประมวลผล ชื่อสถานศึกษา
              คณะที่สนใจและหลักสูตรที่มีความสนใจ ข้อมูลการเข้าใช้งานระบบ
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.3 ข้อมูลอื่น ๆ เช่น การใช้งานระบบ
              เสียง ภาพนิ่ง ภาพเคลื่อนไหว
              และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp; 4.2 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)
              คือ ข้อมูลส่วนบุคคลที่กฎหมายกำหนดเป็นการเฉพาะซึ่ง มทร.ล้านนา
              จะเก็บรวบรวม ใช้
              และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน
              หรือในกรณีที่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต
              เพื่อวัตถุประสงค์ในการพิสูจน์และยืนยันตัวตนของผู้ใช้บริการที่ขอสมัคร
              และ/หรือทำธุรกรรมผ่านช่องทางดิจิทัล เว็บไซต์ หรือช่องทางอื่นใด
              เป็นต้น
              <br />
              &emsp;&emsp; 4.3 ข้อมูลด้านเทคนิค อาทิ
              ข้อมูลการเข้าใช้งานเว็บไซต์และระบบต่าง ๆ ของ มทร.ล้านนา
              ข้อมูลจราจรทางคอมพิวเตอร์ (Log)
              ข้อมูลการติดต่อและสื่อสารระหว่างท่านและผู้ใช้งานรายอื่น
              ข้อมูลจากการบันทึกการใช้งาน เช่น ตัวระบุอุปกรณ์ หมายเลข IP
              ของคอมพิวเตอร์ รหัสประจำตัวอุปกรณ์ ประเภทอุปกรณ์
              ข้อมูลเครือข่ายมือถือ ข้อมูลการเชื่อมต่อ
              ข้อมูลตำแหน่งที่ตั้งทางภูมิศาสตร์ ประเภทของเบราว์เซอร์ (Browser)
              ข้อมูลบันทึกการเข้าออกระบบ
              ข้อมูลแอปพลิเคชันหรือเว็บไซต์ที่ท่านเข้าถึงก่อนและหลัง (Referring
              Website) ข้อมูลบันทึกประวัติการใช้ระบบ ข้อมูลบันทึกการเข้าสู่ระบบ
              (Login Log) พฤติกรรมการใช้งาน (Customer Behavior) สถิติการเข้าระบบ
              เวลาที่เยี่ยมชมระบบ (Access Time) ข้อมูลที่ท่านค้นหา
              การใช้ฟังก์ชันต่าง ๆ ในระบบ และข้อมูลที่ได้เก็บรวบรวมผ่านคุกกี้
              (Cookies) หรือเทคโนโลยีอื่นที่คล้ายกัน
            </div>
            <div class="text-left mt-2">
              <b>5. แนวทางในการดำเนินการคุ้มครองข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp;มทร.ล้านนา จะจัดเก็บข้อมูลส่วนบุคคลเท่าที่จำเป็น
              โดยคำนึงถึงวัตถุประสงค์และความจำเป็น ทั้งนี้ มทร.ล้านนา
              จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นอย่างดีตามมาตรการป้องกันด้านการบริหารจัดการ
              (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical
              safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard)
              เพื่อรักษาความมั่นคงปลอดภัยในการประมวลผลข้อมูลส่วนบุคคลที่เหมาะสม
              หมายความว่า มีการธำรงไว้ซึ่งความลับ (confidentiality)
              ความถูกต้องครบถ้วน (integrity)
              และให้ข้อมูลอยู่ในลักษณะที่พร้อมใช้งาน (availability)
              และเพื่อป้องกันการละเมิดข้อมูลส่วนบุคคล โดยได้กำหนดนโยบาย ระเบียบ
              และหลักเกณฑ์ในการคุ้มครองข้อมูลส่วนบุคคล เช่น
              มาตรฐานความปลอดภัยของระบบเทคโนโลยีสารสนเทศ
              และมาตรการเพื่อป้องกันไม่ให้ผู้รับข้อมูลไปจาก มทร.ล้านนา
              ใช้หรือเปิดเผยข้อมูลนอกวัตถุประสงค์ หรือโดยไม่มีอำนาจหรือโดยไม่ชอบ
              และ มทร.ล้านนา ได้มีการปรับปรุงนโยบาย ระเบียบ
              และหลักเกณฑ์ดังกล่าวเป็นระยะ ๆ ตามความจำเป็นและเหมาะสม
              <br />
              &emsp;&emsp;โดยสิทธิของท่านในข้อนี้เป็นสิทธิตามกฎหมายที่ท่านควรทราบ
              โดยท่านสามารถขอใช้สิทธิต่าง ๆ ได้ภายใต้ข้อกำหนดของกฎหมาย
              และนโยบายที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต
              ตลอดจนหลักเกณฑ์ตามที่ มทร.ล้านนา กำหนดขึ้น
              และในกรณีท่านมีอายุไม่ครบ 20 ปีบริบูรณ์
              หรือถูกจำกัดความสามารถในการทำนิติกรรมตามกฎหมาย
              ท่านสามารถขอใช้สิทธิโดยให้บิดาและมารดา ผู้ใช้อำนาจปกครอง
              หรือมีผู้อำนาจกระทำการแทนเป็นผู้แจ้งความประสงค์
            </div>
            <div class="text-left mt-2">
              <b>6. สิทธิในการเข้าถึง</b>
              <br />
              &emsp;&emsp;มทร.ล้านนา
              ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขช่องทางการให้บริการหรือเนื้อหาใด
              ๆ บนเว็บไซต์นี้ ในเวลาใด ๆ นอกจากนี้
              มทร.ล้านนาสงวนสิทธิที่จะปฏิเสธหรือจำกัดการเข้าถึงเว็บไซต์นี้ของบุคคลใด
              หรือจากเลขที่อยู่อินเตอร์เน็ต (IP Address) ใด
              โดยไม่จำเป็นต้องบอกกล่าวหรือระบุเหตุผลในการดำเนินการนั้น
            </div>
            <div class="text-left mt-2">
              <b>7. การทบทวนและเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; มทร.ล้านนา
              อาจทำการปรับปรุงหรือแก้ไขนโยบายนี้เป็นครั้งคราวเพื่อให้สอดคล้องกับข้อกำหนดตามกฎหมาย
              การเปลี่ยนแปลงการดำเนินงานของ มทร.ล้านนา
              รวมถึงข้อเสนอแนะและความคิดเห็นจากหน่วยงานต่าง ๆ
              โดยจะทำการประกาศแจ้งการเปลี่ยนแปลงให้ทราบอย่างชัดเจน
              ก่อนจะเริ่มดำเนินการเปลี่ยนแปลงใด ๆ
            </div>
            <div class="modal-footer d-flex justify-content-center align-items-center pb-5 pt-3">
              <button type="button" class="btn btn-primary" @click="setIsConsent">
                <i class="ti ti-check"></i>
                &nbsp;ยอมรับเงื่อนไข
              </button>
              <button type="button" id="closeModal" style="display: none;" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- model consent -->
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { Select2 } from 'select2-vue-component'
import 'select2-component/dist/select2.min.css'
import Swal from 'sweetalert2'
import api from '../assets/services'
import $ from 'jquery'

export default {
  components: {
    HeaderView,
    VueBootstrapTypeahead,
    Select2,
  },
  data() {
    return {
      school_lists: [],
      citizen_id: '',
      fullname: '',
      tel: '',
      email: '',
      school: '',
      isConsent: 0,
      gender: 0,
      origin_province_id: 0,
      userType: '',
      campus_list: [],
      campus_id: 0,
      fac_list: [],
      facId: 0,
      major_list: [],
      major: 0,
      dep_list: [],
      dep_id: 0,
      province_list: [],
      isSubmitted: false,
      participant_status: 'นักเรียน',
    }
  },
  computed: {
    schoolInputClass() {
      return ['form-control', this.validationClass('school')].filter(Boolean).join(' ')
    },
    provinceOptions() {
      return [
        { value: 0, label: 'กรุณาเลือกภูมิลำเนา' },
        ...this.province_list.map((prv) => ({
          value: prv.province_id,
          label: prv.province_name,
        })),
      ]
    },
    departmentOptions() {
      const facultyId = Number(this.facId)
      const departmentList = facultyId > 0
        ? this.dep_list.filter((dep) => Number(dep.faculty_id) === facultyId)
        : this.dep_list

      return [
        { value: 0, label: 'กรุณาเลือกหลักสูตร' },
        ...departmentList.map((dep) => ({
          value: dep.department_id_pri,
          label: dep.department_name,
        })),
      ]
    },
    majorOptions() {
      return [
        { value: 0, label: 'กรุณาเลือกสาขาวิชา' },
        ...this.major_list.map((mj) => ({
          value: mj.major_id_pri,
          label: mj.major_name,
        })),
      ]
    },
  },
  watch: {
    facId() {
      this.resetDepartmentIfUnavailable()
    },
    dep_list() {
      this.resetDepartmentIfUnavailable()
    },
    major_list() {
      this.resetMajorIfUnavailable()
    },
  },
  methods: {
    setDepartment(depId) {
      this.dep_id = depId
    },
    resetDepartmentIfUnavailable() {
      const depId = Number(this.dep_id)
      if (depId === 0) {
        return
      }

      const isAvailable = this.departmentOptions.some((dep) => Number(dep.value) === depId)
      if (!isAvailable) {
        this.dep_id = 0
      }
    },
    resetMajorIfUnavailable() {
      const majorId = Number(this.major)
      if (majorId === 0) {
        return
      }

      const isAvailable = this.majorOptions.some((mj) => Number(mj.value) === majorId)
      if (!isAvailable) {
        this.major = 0
      }
    },
    isBlank(value) {
      return value === null || value === undefined || String(value).trim() === ''
    },
    isZero(value) {
      return Number(value) === 0
    },
    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())
    },
    isValidTel(value) {
      return String(value).replace(/\D/g, '').length === 10
    },
    isFieldValid(field) {
      const validations = {
        citizen_id: !this.isBlank(this.citizen_id) && [9, 13].includes(String(this.citizen_id).length),
        gender: !this.isZero(this.gender),
        fullname: !this.isBlank(this.fullname),
        tel: !this.isBlank(this.tel) && this.isValidTel(this.tel),
        email: !this.isBlank(this.email) && this.isValidEmail(this.email),
        origin_province_id: !this.isZero(this.origin_province_id),
        school: !this.isBlank(this.school),
        campus_id: !this.isZero(this.campus_id),
        facId: !this.isZero(this.facId),
        major: !this.isZero(this.major),
        participant_status: !this.isZero(this.participant_status),
      }

      return validations[field] === true
    },
    validationClass(field) {
      if (!this.isSubmitted) {
        return ''
      }

      return this.isFieldValid(field) ? 'is-valid' : 'is-invalid'
    },
    showValidationAlert(text) {
      return Swal.fire({
        title: 'ตรวจสอบ',
        text,
        icon: 'warning',
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: 'ตกลง',
        denyButtonText: 'ยกเลิก',
      })
    },
    validateProfileData() {
      const validations = [
        {
          invalid: this.isBlank(this.citizen_id) || ![9, 13].includes(String(this.citizen_id).length),
          message: 'กรุณาตรวจสอบรหัสบัตรประชาชนหรือเลขพาสปอร์ต/Citizen&Passportid',
        },
        {
          invalid: this.isZero(this.gender),
          message: 'กรุณาเลือกเพศ',
        },
        {
          invalid: this.isBlank(this.fullname),
          message: 'กรุณากรอกชื่อ - นามสกุล/Fullname',
        },
        {
          invalid: this.isBlank(this.tel) || !this.isValidTel(this.tel),
          message: 'กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก/Telephone',
        },
        {
          invalid: this.isBlank(this.email) || !this.isValidEmail(this.email),
          message: 'กรุณากรอกอีเมลให้ถูกต้อง/Email',
        },
        {
          invalid: this.isZero(this.origin_province_id),
          message: 'กรุณาเลือกภูมิลำเนา/Origin Province',
        },
        {
          invalid: this.isBlank(this.school),
          message: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/School',
        },
        {
          invalid: this.isZero(this.campus_id),
          message: 'กรุณาเลือกเขตพื้นที่ที่สนใจ/Campus',
        },
        {
          invalid: this.isZero(this.facId),
          message: 'กรุณาเลือกคณะที่สนใจ/Faculty',
        },
        {
          invalid: this.isZero(this.major),
          message: 'กรุณาเลือกสาขาวิชาที่สนใจ/Major',
        },
        {
          invalid: this.isZero(this.participant_status),
          message: 'กรุณาเลือกสถานะผู้เข้าร่วม/Participant Status',
        },
      ]

      return validations.find((validation) => validation.invalid)
    },
    setIsConsent() {
      $('#closeModal').click()
      this.isConsent = 1
    },
    validateForm() {
      this.isSubmitted = true

      if (this.isConsent !== 1) {
        $('#consentRule').click()
        return
      }

      const invalidProfileData = this.validateProfileData()
      if (invalidProfileData) {
        this.showValidationAlert(invalidProfileData.message)
        return
      }

      const $myForm = $('#formprofile')
      if (!$myForm[0].checkValidity()) {
        this.showValidationAlert('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
        return
      }

      this.register()
    },
    register() {
      this.$store.state.isLoading = true

      const selectedCampus = this.campus_list.find((cp) => Number(cp.campus_id_pri) === Number(this.campus_id))
      const department = this.dep_list.find((dep) => Number(dep.department_id_pri) === Number(this.dep_id))
      const payload = {
        citizenId: this.citizen_id,
        fullname: this.fullname,
        email: this.email,
        tel: this.tel,
        school: this.school,
        facId: this.facId,
        depName: department ? department.department_name : '',
        gender: this.gender,
        campus_id_pri: this.campus_id,
        department_id_pri: this.dep_id,
        major_id_pri: this.major,
        origin_province: this.origin_province_id,
        isConsent: this.isConsent,
        campus: selectedCampus ? selectedCampus.campus_name : '',
        participant_status: this.participant_status,
      }

      api.registerUser(
        this.$store.state.URL,
        payload,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            localStorage.token = result.data.accessToken
            setTimeout(() => {
              this.OAuth(this.citizen_id)
              this.$router.push('/activity').catch(() => { })
              this.$store.state.isLoading = false
            }, 1000)
          } else if (result.status === 'ALREADY_IN_USE') {
            this.$store.state.isLoading = false
            this.$router.push('/activity').catch(() => { })
          } else {
            this.$store.state.isLoading = false
            if (this.school === '') {
              Swal.fire({
                title: 'ตรวจสอบ',
                text: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/school',
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'ตกลง',
                denyButtonText: 'ยกเลิก',
              }).then((result) => {
                console.log(result)
              })
            }
            // Swal.fire({
            //   title: 'ตรวจสอบ',
            //   text: result.message,
            //   icon: 'warning',
            //   showDenyButton: false,
            //   showCancelButton: false,
            //   confirmButtonText: 'เข้าสู่ระบบใหม่',
            //   denyButtonText: 'ยกเลิก',
            // }).then((result) => {
            //   localStorage.clear()
            //   this.$router.push('/').catch(() => {})
            // })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          // localStorage.clear()
          // this.$router.push('/').catch(() => {})
        },
      )
    },
    CheckUser(citizenId) {
      this.$store.state.isLoading = true
      api.OAuthCheck(
        this.$store.state.URL,
        { citizenId: citizenId },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            // localStorage.token = result.data.accessToken
            this.OAuth(citizenId)
            // this.$router.push('/activity').catch(() => { })
          } else if (result.status === 'NOT_REGISTER') {
            // this.$router.push({ name: 'Regis', params: { id: citizenId } }).catch(() => { })
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getProvince() {
      this.$store.state.isLoading = true
      api.getProvince(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.province_list = result.data
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getSchools() {
      this.$store.state.isLoading = true
      api.schoolData(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.school_lists = []
            result.data.forEach((v) => {
              this.school_lists.push(v['school_name'])
            })
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getCampus() {
      this.$store.state.isLoading = true
      api.getCampus(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.campus_list = result.data
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getFac() {
      this.$store.state.isLoading = true
      api.getFaculty(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.fac_list = result.data
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getDepart() {
      this.$store.state.isLoading = true
      api.getDepartment(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.dep_list = result.data
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getMajor() {
      this.$store.state.isLoading = true
      api.getMajor(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.major_list = result.data
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.citizen_id = this.$route.params.id
      if (this.citizen_id.length === 9 || this.citizen_id.length === 13) {
        this.CheckUser(this.citizen_id)
        this.getSchools()
        this.getProvince()
        this.getCampus()
        this.getFac()
        this.getDepart()
        this.getMajor()
        $('#consentRule').click()
      } else {
        localStorage.clear()
        this.$router.push('/').catch(() => { })
      }
    } else {
      this.$router.push('/').catch(() => { })
    }
  },
}
</script>

<style>
.vbt-autcomplete-list[data-v-9a21a6f4] {
  background-color: #ffffff !important;
}

.form-page {
  width: min(1180px, calc(100% - 20px));
  margin: 0 auto;
  padding: 22px 0 110px;
  font-family: 'Mitr', sans-serif;
}

.form-card {
  border: 1px solid rgba(116, 87, 60, 0.16);
  border-radius: 8px;
  padding: 26px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 20px 54px rgba(76, 50, 31, 0.13);
}

.form-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 1px solid rgba(116, 87, 60, 0.12);
}

.heading-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 14px 28px rgba(185, 130, 46, 0.22);
}

.heading-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.form-heading p {
  margin: 0 0 4px;
  color: #8a714f;
  font-size: 13px;
}

.form-heading h2 {
  margin: 0;
  color: #2f241b;
  font-size: 30px;
  font-weight: 600;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 18px;
}

.form-field {
  min-width: 0;
}

.field-wide {
  grid-column: 1 / -1;
}

.form-field label {
  display: block;
  margin-bottom: 8px;
  color: #3d3025;
  font-size: 14px;
  font-weight: 500;
}

.form-field .form-control,
.form-field .form-select {
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
  margin-bottom: 0 !important;
  border-color: #dccdb9;
  color: #2f241b;
  background-color: #ffffff;
  font-family: 'Mitr', sans-serif;
}

.form-field .form-control:focus,
.form-field .form-select:focus {
  border-color: #b9822e;
  box-shadow: 0 0 0 0.25rem rgba(185, 130, 46, 0.16);
}

.form-actions {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.form-actions .btn {
  min-height: 48px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Mitr', sans-serif;
  font-size: 18px;
}

.btn-primary-action {
  border: 0;
  color: #ffffff !important;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  box-shadow: 0 14px 26px rgba(185, 130, 46, 0.22);
}

.btn-primary-action i,
.btn-primary-action span {
  color: #ffffff !important;
}

.btn-secondary-action {
  border: 1px solid #dccdb9;
  color: #5a3b25;
  background: #fffaf0;
}

.regis-select2.select2-container {
  display: block;
  width: 100% !important;
  font-family: 'Mitr', sans-serif;
  font-size: 0.875rem;
  line-height: 1.4285714286;
}

.regis-select2 .select2-selection--single {
  height: 44px !important;
  min-height: 44px;
  box-sizing: border-box;
}

.regis-select2.select2-container--default .select2-selection--single {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.4375rem 2.25rem 0.4375rem 0.75rem;
  color: inherit;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23a5a9b1' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #dccdb9;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.regis-select2.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.select2-container--default:focus-within .select2-selection--single {
  border-color: #b9822e;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(185, 130, 46, 0.16);
}

.regis-select2.is-invalid.select2-container--default .select2-selection--single,
.regis-select2.is-invalid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-invalid.select2-container--default:focus-within .select2-selection--single {
  border-color: #d63939;
}

.regis-select2.is-invalid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-invalid.select2-container--default:focus-within .select2-selection--single {
  box-shadow: 0 0 0 0.25rem rgba(214, 57, 57, 0.25);
}

.regis-select2.is-valid.select2-container--default .select2-selection--single,
.regis-select2.is-valid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-valid.select2-container--default:focus-within .select2-selection--single {
  border-color: #2fb344;
}

.regis-select2.is-valid.select2-container--default.select2-container--open .select2-selection--single,
.regis-select2.is-valid.select2-container--default:focus-within .select2-selection--single {
  box-shadow: 0 0 0 0.25rem rgba(47, 179, 68, 0.25);
}

.regis-select2.select2-container--default .select2-selection--single .select2-selection__rendered {
  padding: 0;
  color: inherit;
  line-height: 1.4285714286;
}

.regis-select2.select2-container--default .select2-selection--single .select2-selection__arrow {
  display: none;
}

.regis-select2 .select2-container-dropdown {
  top: 100%;
}

.regis-select2 .select2-dropdown {
  border-color: #d9dbde;
  font-family: 'Mitr', sans-serif;
  font-size: 0.875rem;
}

@media (max-width: 767px) {
  .form-page {
    width: calc(100% - 12px);
    padding-top: 14px;
  }

  .form-card {
    padding: 18px;
  }

  .form-heading {
    margin-bottom: 18px;
  }

  .form-heading h2 {
    font-size: 25px;
  }

  .form-grid,
  .form-actions {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Regis.vue